<script>
import { stripePriceToString } from "/vodalys2023/stripe/stripe.utils.mjs";

export default {
  components: {},
  methods: {},
  props: {
    component: Object,
    handler: Object,
    chosen: Boolean,
  },
  data: function () {
    return {};
  },
};
</script>

<template>
  <div class="plan-tunnel-default" :class="{
      'most-popular': component.meta.most_popular,
      'current-plan': component.is_current_plan,
      chosen: chosen,
    }">
    <div class="plan-tunnel-default-title">{{ component.meta.title }}</div>
    <div class="plan-tunnel-default-description">
      {{ component.meta.description }}
    </div>
    <div class="plan-tunnel-default-subdescription">
      {{ component.meta.subdescription }}
    </div>
    <div class="plan-tunnel-default-current-plan" v-if="component.is_current_plan">
      {{ $vt("Current plan") }}
    </div>
    <div class="plan-tunnel-default-line"></div>
    <div class="plan-tunnel-default-list">
      <div class="list-item" v-for="(list_item, index) in component.meta.list" :key="index">
        <div class="list-item-icon"><f-icon icon="fa6-check"></f-icon></div>
        <div>{{ list_item.text }}</div>
      </div>
    </div>
    <div class="plan-tunnel-default-expire_at" v-if="component.is_current_plan">
      {{ $vt("Expired of plan :") }}
      {{ (component.expire_at * 1000) | angularFilter("MMMM, dd", "date") }}
    </div>
    <div class="plan-tunnel-default-upgrade">
      <f-button type="primary" blank :href="component.meta.contact_url"><f-icon icon="fa6-envelope"></f-icon>{{ $vt("Contact sales") }}</f-button>
    </div>
  </div>
</template>

<style lang="scss">
.plan-tunnel-default {
  width: 300px;
  background: var(--black);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px;
  border-radius: 12px;
  position: relative;
  box-shadow: 0px 24px 32px -8px rgba(22, 22, 21, 0.12);

  &.most-popular:after {
    content: "";
    width: 125px;
    height: 125px;
    position: absolute;
    top: -23px;
    right: -23px;
    background-image: url(popular.png);
  }

  &.current-plan {
    box-shadow: inset 0px 0px 0px 4px var(--navigation);
  }
  .plan-tunnel-default-title {
    text-align: center;
    font-family: Lato;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 36px */
    color: var(--primary);
  }

  .plan-tunnel-default-cost {
    text-align: center;
    color: var(--white-a90);
    font-family: Lato;
    font-size: 60px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 60px */
  }

  .plan-tunnel-default-description {
    color: var(--white-90, rgba(255, 255, 255, 0.9));
    text-align: center;
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 24px */
  }

  .plan-tunnel-default-subdescription {
    color: var(--white-90, rgba(255, 255, 255, 0.9));
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 24px */
  }

  .plan-tunnel-default-current-plan {
    align-self: center;
    display: flex;
    color: var(--white-a75);
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 8px 12px;
    background-color: var(--navigation);
    border-radius: 24px;
    text-transform: uppercase;
  }

  .plan-tunnel-default-line {
    margin: 0 16px;
    height: 2px;
    border-radius: 1px;
    background: #373838;
  }

  .plan-tunnel-default-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    .list-item {
      display: flex;
      align-items: center;
      gap: 8px;
      color: var(--white-a75);
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 125%; /* 20px */

      .list-item-icon {
        color: var(--primary);
        font-weight: bold;
      }
    }
  }

  .plan-tunnel-default-expire_at {
    display: flex;
    justify-content: center;
    margin: 16px 0;
    color: var(--white-a75);
    text-align: center;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%;
  }

  .plan-tunnel-default-upgrade {
    .f-button {
      width: 100%;
    }
  }

  .plan-tunnel-default-additionnal-hour {
    display: flex;
    gap: 8px;
    align-self: center;
    color: var(--white-a75);
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%; /* 20px */
  }

  &.chosen {
    .plan-tunnel-default-current-plan,
    .plan-tunnel-default-upgrade {
      display: none;
    }

    .plan-tunnel-default-line {
      margin-bottom: auto;
    }
  }
}
</style>